@if (garage) {
  <!-- Mobile -->
  <div class="block md:hidden text-center mb-4">
    <div class="headline-small mb-1" [innerText]="garage.name"></div>
    <div class="body-large">
      <span class="text-decoration-dark" [innerText]="formatAddress(garage)"></span>
    </div>
  </div>

  <!-- Desktop -->
  <div class="hidden md:block">
    <div class="headline-x-small mb-2">
      <span [innerText]="garage.name"></span>
      <span class="font-light">&nbsp;&nbsp;</span>
      <span class="font-light" [innerText]="formatAddress(garage)"></span>
    </div>
    <hr class="mb-4" />
  </div>

  <div class="flex flex-col xl:flex-row gap-4">
    <div class="xl:flex-shrink-0" [ngClass]="showWiparkShortTermParking ? 'xl:w-[50%]' : 'xl:w-full'">
      <div class="body-large mb-0.5">
        <div class="text-decoration-dark">
          <i class="fa-kit fa-contract mr-1.5"></i>
          <span class="font-medium" [innerText]="'Locations.Contracts' | translate"></span>
        </div>
      </div>
      <div class="body-small mb-2">
        <span class="text-neutral-50" [innerText]="'Locations.LongTermParkingDescription' | translate"></span>
      </div>
      @if (bookableContractTemplates.length > 0) {
        <div class="flex flex-col gap-2">
          @for (contractTemplate of bookableContractTemplates; track contractTemplate.id) {
            <div
              class="card card-small"
              (click)="sendAddContractEventToAmplitude()"
              [ngClass]="{
                'hover:bg-decoration-transparent-4 cursor-pointer': creatingContractEnabled,
              }"
              [routerLink]="creatingContractEnabled ? '/contracts/create' : null"
              [queryParams]="{ garageId: garage!.id, productId: contractTemplate.id }"
            >
              <div class="card-body flex items-center justify-between gap-4 group">
                <div class="flex-shrink overflow-hidden text-left">
                  <div class="body-medium overflow-hidden whitespace-nowrap overflow-ellipsis mb-0.5">
                    <span class="font-medium text-decoration-dark" [innerText]="contractTemplate.name"></span>
                  </div>
                  <div class="body-medium overflow-hidden whitespace-nowrap overflow-ellipsis" *ngIf="contractTemplate.description">
                    <span class="text-neutral-30" [innerText]="contractTemplate.description"></span>
                  </div>
                </div>
                <div class="flex items-center gap-4">
                  <div class="text-right">
                    <div class="body-medium text-interaction mb-0.5">
                      <span class="font-medium">
                        <ng-container *ngIf="contractTemplate.price_adjustment">{{ 'Common.From' | translate }}</ng-container>
                        {{ contractTemplate.price.amount | localizedCurrency: contractTemplate.price.currency }}
                      </span>
                    </div>
                    <div class="body-medium" [innerText]="'Common.Monthly' | translate"></div>
                  </div>
                  @if (creatingContractEnabled) {
                    <div>
                      <i class="fa-kit fa-contract-new text-2xl text-interaction-dark group-hover:text-interaction"></i>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (informationContractTemplates.length > 0) {
        <div class="body-large text-decoration-dark mt-4" [innerText]="'Contracts.NotBookableOnline' | translate"></div>
        <div class="body-small mt-0.5 mb-2">
          <span class="text-neutral-50" [innerText]="'Contracts.ContactUsToBookAdditionalContracts' | translate"></span>
        </div>
        <div class="flex flex-col gap-2">
          @for (contractTemplate of informationContractTemplates; track contractTemplate.id) {
            <div class="card card-small bg-surface-70">
              <div class="card-body flex items-center justify-between gap-4 group">
                <div class="flex-shrink overflow-hidden text-left">
                  <div class="body-medium overflow-hidden whitespace-nowrap overflow-ellipsis mb-0.5">
                    <span class="font-medium text-decoration-dark" [innerText]="contractTemplate.name"></span>
                  </div>
                  <div class="body-medium overflow-hidden whitespace-nowrap overflow-ellipsis" *ngIf="contractTemplate.description">
                    <span class="text-neutral-30" [innerText]="contractTemplate.description"></span>
                  </div>
                </div>
                <div class="flex items-center gap-4">
                  <div class="text-right">
                    <div class="body-medium text-interaction mb-0.5">
                      <span class="font-medium">
                        <ng-container *ngIf="contractTemplate.price_adjustment">{{ 'Common.From' | translate }}</ng-container>
                        {{ contractTemplate.price.amount | localizedCurrency: contractTemplate.price.currency }}
                      </span>
                    </div>
                    <div class="body-medium" [innerText]="'Common.Monthly' | translate"></div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (noContractsAvailable) {
        <div class="body-medium text-neutral-50 text-center py-4" [innerText]="'Locations.NoContractsAvailable' | translate"></div>
      }
      <div
        class="body-medium text-neutral-50 text-center py-4 pt-2"
        [ngClass]="noContractsAvailable ? 'border-t-2' : 'border-t-0 mt-3'"
        [innerHtml]="'Products.ContractCreationDisabledInfo' | translate"
        hideIfNoTranslation
      ></div>
    </div>
    @if (showWiparkShortTermParking) {
      <hr class="my-2 block xl:hidden" />
      <div class="xl:w-[50%] xl:flex-shrink-0">
        <div class="body-large mb-0.5">
          <div class="text-decoration-dark mb-0.5">
            <i class="fa-kit fa-time mr-1.5"></i>
            <span class="font-medium" [innerText]="'Locations.TimeBasedParking' | translate"></span>
            <span class="font-medium">:&nbsp;</span>
            <span class="font-light" [innerText]="'Locations.ShortTermParking' | translate"></span>
          </div>
        </div>
        <div class="body-small mb-2">
          <span class="text-neutral-50" [innerText]="'Locations.ShortTermParkingDescription' | translate"></span>
        </div>
        <div class="card card-small">
          <div class="card-body">
            <table class="price-table">
              <th></th>
              <tr>
                <td class="body-medium align-top">
                  <span class="font-medium text-decoration-dark" [innerText]="'Locations.Tariffs.Wipark.HourlyRate' | translate"></span>
                </td>
              </tr>
              <tr>
                <td class="body-medium align-top">
                  <span class="text-neutral-30" [innerText]="'Locations.Tariffs.Wipark.HourlyRateDescription' | translate"></span>
                </td>
              </tr>
              <tr>
                <td class="py-2">
                  <hr />
                </td>
              </tr>
              <tr>
                <td class="body-medium align-top">
                  <span class="font-medium text-decoration-dark" [innerText]="'Locations.Tariffs.Wipark.EveningFlatRate' | translate"></span>
                </td>
              </tr>
              <tr>
                <td class="body-medium align-top">
                  <span class="text-neutral-30" [innerText]="'Locations.Tariffs.Wipark.EveningFlatRateDescription' | translate"></span>
                </td>
              </tr>
              <tr>
                <td class="py-2">
                  <hr />
                </td>
              </tr>
              <tr>
                <td class="body-medium align-top">
                  <span class="font-medium text-decoration-dark" [innerText]="'Locations.Tariffs.Wipark.DailyRate' | translate"></span>
                </td>
              </tr>
              <tr>
                <td class="body-medium align-top">
                  <span class="text-neutral-30" [innerText]="'Locations.Tariffs.Wipark.DailyRateDescription' | translate"></span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    }
  </div>
}
